import App from 'app/app.js';

function LtPictureDayFormCtrlService(JobStore) {
  this.prepopulate = false;

  this.setPrePopulate = function (prepop) {
    this.prepopulate = prepop;
  };
  this.getPrePopulate = function () {
    return this.prepopulate;
  };
  this.getJobNumber = function () {
    if (this.prepopulate) {
      var job = JobStore.getJob();
      if (job) {
        return job.jobNumber;
      }
    }
  };
}

App.service('LtPictureDayFormCtrlService', ['JobStore', LtPictureDayFormCtrlService]);
